import FormikWizard from "formik-wizard";
import React from "react";
import schema from "../schema";
function FormWrapper({
  children,
  isLastStep,
  status,
  goToPreviousStep,
  canGoBack,
  actionLabel
}) {
  return (
    <div>
      {status && (
        <div>
          {status.message}
          <hr />
        </div>
      )}
      {canGoBack && 
      <div className="form-header">
        <button type="button" className="button--back prev-step" onClick={goToPreviousStep} disabled={!canGoBack}>
          <span>Back</span>
        </button>
      </div>
      }
      
      <div className="form-body">
      {children}
      </div>
    </div>
  );
}
function App() {
  const handleSubmit = React.useCallback(values => {
    //console.log("full values:", values);
  }, []);
  return (
    <FormikWizard steps={schema} onSubmit={handleSubmit} render={FormWrapper} />
  );
}
export default App;
